import { NativeSelect } from "@mantine/core"
import React from "react"
import { GenericFieldProps } from "src/utils/forms"

const getAgencyRoleOptions = (department: string) => {
    if (!department) return []
    return [
        { label: `Admin`, value: `agency_${department}_administrator` },
        { label: `User`, value: `agency_${department}_user` }
    ]
}

export const AgencyRoleSelect: React.FC<GenericFieldProps> = ({
    id, name, label, onChange, onBlur, value, error, required, disabled, description, classNames, getValues
}) => {

    const department = getValues?.type || ''
    const options = React.useMemo(() => getAgencyRoleOptions(department), [department])

    React.useEffect(() => {
        if (department && value && !value.startsWith(`agency_${department}_`)) {
            onChange(`agency_${department}_administrator`)
        }
    }, [department])

    return (
        <NativeSelect
            id={id}
            name={name}
            label={label}
            data={[
                { label: 'Select Role...', value: '' },
                ...options
            ]}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                onChange(e.target.value)
            }}
            onBlur={onBlur}
            value={value || ''}
            error={error as string}
            required={required}
            disabled={!department || disabled}
            description={description}
            classNames={classNames}
        />
    )
}
